import Url from 'urlinator/Url';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PrivateReportLink } from './PrivateReportLink';
import { DisabledReportLink } from './DisabledReportLink';
import { ReportDescription } from '../../ReportDescription';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error Untyped import
import { trackEvent, EVENTS } from '../../../lib/usageTracker';
// @ts-expect-error Untyped import
import { selectSearchFilter } from '../../../selectors/reportsSelector';
import { Link } from 'foundations-components/transitional/components/Link';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
// @ts-expect-error Untyped import
import { PERMISSION_DENIED } from 'dashboard-lib/private/action-problem-solution/actions/view-report/problem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const trackOpenReport = (reportToOpen, search) => trackEvent(EVENTS.openReport, {
  subscreen: search ? 'global-search' : 'reports-list',
  subAppKey: reportToOpen.getIn(['displayParams', 'salesAnalytics', 'subAppKey'])
});
export const ReportLink = ({
  report,
  problem,
  TooltipMessage,
  showDescription = true
}) => {
  const reportName = report.get('name');
  const history = useHistory();
  const search = useSelector(selectSearchFilter);
  const handleClickReportLink = useCallback(() => {
    trackOpenReport(report, search);
    const url = new Url(window.location);
    const reportId = report.get('id');
    history.push(`/${reportId}/${url.search}`);
  }, [report, history, search]);
  if (problem && problem === PERMISSION_DENIED.toString()) {
    return /*#__PURE__*/_jsx(PrivateReportLink, {
      TooltipMessage: TooltipMessage
    });
  }
  if (problem) {
    return /*#__PURE__*/_jsx(DisabledReportLink, {
      reportName: reportName,
      TooltipMessage: TooltipMessage,
      problem: problem
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [showDescription && /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(ReportDescription, {
        report: report
      }),
      marginInlineEnd: "100",
      marginBlockStart: "100"
    }), /*#__PURE__*/_jsx(Link, {
      onClick: handleClickReportLink,
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "report-row-name",
        "data-test-report-name": reportName,
        children: /*#__PURE__*/_jsx(TruncateString, {
          children: /*#__PURE__*/_jsx("span", {
            children: reportName
          })
        })
      })
    })]
  });
};